<template>
  <BaskitAccordion
    header-field="statusName"
    key-field="status"
    :items="supportUserStore.groupedRequestsByStatus"
    style="width: 100%"
    v-model:expandedPanelKey="selectedRequestsGroupKey"
  >
    <template #panelData="{ item }">
      <template v-if="!!item.requests.length">
        <SupportUserRequest
          v-for="request in item.requests"
          :key="request.id"
          :request="request"
          style="margin-left: 15px; margin-right: 15px"
        />
        <a-flex
          align="center"
          justify="center"
          style="width: 100%"
          v-if="
            !!supportUserStore.pagination[item.status as RequestStatus]!
              .total &&
            supportUserStore.pagination[item.status as RequestStatus]!.total >
              supportUserStore.pagination[item.status as RequestStatus]!
                .pageSize
          "
        >
          <a-pagination
            v-model:current="
              supportUserStore.pagination[item.status as RequestStatus]!.current
            "
            :total="
              supportUserStore.pagination[item.status as RequestStatus]!.total
            "
            v-model:pageSize="
              supportUserStore.pagination[item.status as RequestStatus]!
                .pageSize
            "
            :pageSizeOptions="
              supportUserStore.pagination[item.status as RequestStatus]!
                .pageSizeOptions
            "
            :defaultPageSize="
              supportUserStore.pagination[item.status as RequestStatus]!
                .defaultPageSize
            "
            @change="
              supportUserStore.pagination[item.status as RequestStatus]!
                .onChangePagination
            "
            :showQuickJumper="
              supportUserStore.pagination[item.status as RequestStatus]!
                .showQuickJumper
            "
            :showSizeChanger="
              supportUserStore.pagination[item.status as RequestStatus]!
                .showSizeChanger
            "
            :showLessItems="
              supportUserStore.pagination[item.status as RequestStatus]!
                .showLessItems
            "
            :showTotal="
              supportUserStore.pagination[item.status as RequestStatus]!
                .showTotal
            "
            :size="'small'"
          />
        </a-flex>
      </template>
      <a-empty
        v-else
        :description="`Нет обращений в статусе '${item.statusName}'`"
      />
    </template>

    <template #headerData="{ item }">
      <SupportRequestsGroupHeader
        :header="item.statusName"
        :newMessagesCount="
          chatStore.unreadGroupsMessagesCount[item.status as RequestStatus]!
        "
        style="flex-grow: 1"
      />
    </template>
  </BaskitAccordion>
</template>

<script setup lang="ts">
import SupportUserRequest from "@/components/settings/support/user/requests/SupportUserRequest.vue";
import { ref, watchEffect } from "vue";
import { useSupportUserStore } from "@/stores/support/support-user.store";
import BaskitAccordion from "@/components/UI/BaskitAccordion.vue";
import { useChatStore } from "@/stores/chat/chat.store";
import { RequestStatus } from "@/api/api.dto";
import SupportRequestsGroupHeader from "@/components/settings/support/SupportRequestsGroupHeader.vue";

const supportUserStore = useSupportUserStore();
const chatStore = useChatStore();
const selectedRequestsGroupKey = ref<RequestStatus | null>(null);

watchEffect(() => {
  const currentRequest = chatStore.currentRequest;
  if (!currentRequest) return;
  selectedRequestsGroupKey.value = chatStore.currentSelectedStatus;
});
</script>

<style scoped lang="scss"></style>
